import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1902.45,857.571 C1925.849,880.97 1925.849,919.01 1902.45,942.41 L1302.46,1542.4 C1291.179,1553.68 1275.939,1560.04 1259.98,1560.04 L1019.984,1560.04 L0,1560.04 L0,1440.042 L875.146,1440.042 L737.628,1302.404 C714.229,1279.005 714.229,1240.966 737.628,1217.565 L1457.617,497.577 C1481.016,474.177 1519.055,474.177 1542.456,497.577 L1902.45,857.571 Z",
  transform: "translate(0 180)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.452 1180.186L615.086 120.003 120.094 120.003 120.094 0.005 1200.077 0.005 1200.077 120.003 742.164 120.003 356.61 1219.786z",
  transform: "translate(0 180)"
}));

var IconClearTextFormattingSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconClearTextFormattingSolid, _Component);

  var _super = _createSuper(IconClearTextFormattingSolid);

  function IconClearTextFormattingSolid() {
    _classCallCheck(this, IconClearTextFormattingSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconClearTextFormattingSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClearTextFormatting",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClearTextFormattingSolid.displayName = "IconClearTextFormattingSolid";
  return IconClearTextFormattingSolid;
}(Component);

IconClearTextFormattingSolid.glyphName = 'clear-text-formatting';
IconClearTextFormattingSolid.variant = 'Solid';
IconClearTextFormattingSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClearTextFormattingSolid;
export { IconClearTextFormattingSolid };